import React, { Component } from 'react';
import {Modal,Toast,ActivityIndicator} from "antd-mobile";
import axios from "axios";
import storage from "../model/storage";
import Single from "./Single";
import Multi from "./Multi";
import MkTopic from "./MkTopic";
import Completion from "./Completion";
import Answersheet from "./Answersheet";
import globalSubscribe from "../common/globalState";
import "../assects/css/home.css";
const alert = Modal.alert;
class MK extends Component {

  constructor(props) {
    super(props);
    this.state = {
      examId:"",
      paperId:"",
      userId:"",
      isDid:false,
      isShow:false,
      imgSrc:"",
      timeMin:"",
      time:"00:00:00",
      alertInstance:{},
      loading:true
    };
  }
  componentWillMount(){ 
    if(this.props.location.state&&this.props.location.state.examId){
      
    }else{
      this.props.history.replace(`/?examId=${storage.get("examId")}&paperId=${storage.get("paperId")}&market=${storage.get("market")}`);
      window.location.reload();
    }
    
    
    document.title="考试模考|在线模考_山香教育|招教网";
    
   
  }
  componentDidMount(){
    let that = this;
    globalSubscribe.on((state, preState) => {
      // console.log(preState.arr, 'preState ++++++++++++++++');
      // console.log(state.arr, 'state ++++++++++++=');
    })
    
    //console.log(that.props);
    if(this.props.location.state&&this.props.location.state.isDid===true){
      //console.log(that.props);
      this.setState({
        isDid:that.props.location.state.isDid,
        examId: that.props.location.state.examId,
          paperId: that.props.location.state.paperId,
          userId:that.props.location.state.userId
      })
      axios.get(storage.baseUrl+'/showPaper', {
        params: {
          examId: that.props.location.state.examId,
          paperId: that.props.location.state.paperId,
          userId:that.props.location.state.userId
        }
      })
        .then(function (response) {
          // handle success
          //console.log(response);
         // console.log(response.data);
          let questionDates=response.data.questionDatas;
         
          //console.log(response.data);
          that.setState({
            questionDates:questionDates,
            loading:false
          })
          that.child.randerCard();
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })

    }else{
      
      axios.get(storage.baseUrl+'/composePaper', {
        params: {
          examId: that.props.location.state.examId,
          paperId: that.props.location.state.paperId,
          userId:that.props.location.state.userId
        }
      })
        .then(function (response) {
          // handle success
         // console.log(response.data);
          let questionDates=response.data.questionDates;
         
          //console.log(response.data);
          that.setState({
            questionDates:questionDates,
            loading:false
          })
         
          that.child.randerCard();
          
          if(response.data.paperTime>0){
            that.setState({
              timeMin:'本试卷限时'+response.data.paperTime+'分钟'
            })
            that.countFun(response.data.paperTime);
          }else{
            that.setState({
              time:"不限时长",
              timeMin:'本试卷不限时长'
            })
            that.userTime();
          }
          //console.log(response.data.paperTime);
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        
    }
   
  }
  showTime = () => {
    this.state.alertInstance = alert('时间提醒', '距离答题时间结束只剩下15分钟了，时间截止系统将自动交卷，请您注意答题时间噢~', [
      { text: '取消', onPress: () => console.log('cancel'), style: 'default' },
      { text: '确定', onPress: () => console.log('cancel'), style: 'default' },
    ]);

  };
  
  componentWillUnmount() {
  
    clearInterval(this.timer);
}
formatTime=(remaining)=>{
  let hour = Math.floor((remaining / 1000 / 3600) % 24);
  let minute = Math.floor((remaining / 1000 / 60) % 60);
  let second = Math.floor(remaining / 1000 % 60);
  return (hour>9?hour:'0'+hour)+":"+(minute>9?minute:'0'+minute)+":"+(second>9?second:'0'+second);
}
userTime = () => {
  let userTime=0;
  this.timer = setInterval(() => {
    userTime++;
    storage.set("time",this.formatTime(userTime*1000));
  },1000)
}
countFun = (num) => {   
    var remaining = num*60*1000;
    this.timer = setInterval(() => {
        
        //防止出现负数
        if (remaining > 0) {
            remaining -= 1000;
            
            
            if(remaining === 15*60*1000){
              this.showTime();
            }
            let countTime=this.formatTime(remaining);
            this.setState({
                time:countTime
            })
            storage.set("time",this.formatTime(num*60*1000-remaining));
        } else {
          storage.set("time",this.formatTime(num*60*1000));
            clearInterval(this.timer);
            //倒计时结束时触发父组件的方法
            Toast.info('自动交卷,请主观题自评分', 1);
            if(typeof this.state.alertInstance.close === "function"){
              this.state.alertInstance.close();
            }
           
            
            this.props.history.push( { pathname: "/MkSelf", state: {examId:this.props.location.state.examId,paperId:this.props.location.state.paperId,userId:this.props.location.state.userId} });
           
        }
    }, 1000);
}
  

  componentDidUpdate(){
   
    this.child.randerCard();
  }
  
  onRef = (ref) => {

    this.child = ref

}
  subCard=(questionId,optChoose,correctness,score,questionType)=>{
    if(this.props.location.state&&this.props.location.state.isDid===true){
      return false;
    }else{
      var that = this;
      // axios.get(storage.baseUrl+'/updateAnswerCard', {
      //   params: {
      //     paperId: that.props.location.state.paperId,
      //     questionId: questionId,
      //     userId:that.props.location.state.userId,
      //     optChoose:optChoose,
      //     correctness:correctness,
      //     score:score
      //   }
      // })
      //   .then(function (response) {
      //    debugger
      //  //console.log(response);
         
      //   })
      //   .catch(function (error) {
      //     // handle error
      //     console.log(error);
      //   })
      let obj = {}
      obj = {
        paperId: that.props.location.state.paperId,
        questionId: questionId,
        userId:that.props.location.state.userId,
        optChoose:optChoose.replace(/\n/gm, '').replace(/\s+/g,''),
        correctness:correctness,
        score:score,
        status:optChoose&&optChoose!=''?'1':'0',
        questionType:questionType
      }
      const { arr } = globalSubscribe.getState();
      const newArr = [...arr];
      const currentIndex = newArr.findIndex(o => o.questionId == obj.questionId);
      if(currentIndex > -1) {
        newArr.splice(currentIndex, 1)
      }
      // if(obj.optChoose != "" && obj.optChoose != undefined) {
        newArr.push(obj)
      // }
      globalSubscribe.setArr(newArr);  
      // console.log(globalSubscribe.getState().arr,'4444444444')
    }
    
  }
  onClose =() => {
    this.setState({
     imgShow: false
    });
  }
 imgShow=(e)=>{
  //console.log(e);
  if(e.target.nodeName==="IMG"){
    this.setState({
      imgShow:true,
      imgSrc:e.target.src
    })
  }
 }
  render() {
    const {isDid}=this.state
    return (
      <div>
          <Modal
          className="imgCon"
            visible={this.state.imgShow}
            transparent
            maskClosable={true}
            onClose={this.onClose}
            title="查看图片"
            footer={[{ text: 'Ok', onPress: () => { console.log('ok'); this.onClose();} }]}
            wrapProps={{ onTouchStart: this.onWrapTouchStart }}
            
          >
          <img style={{width:'100%'}} src={this.state.imgSrc} alt="" />
          </Modal>
          {
            this.state.loading==true?
             <div className="loadingCon">
            <ActivityIndicator toast text="正在加载" />
            </div>:<div></div>
          }
     
      <div className="gf_con" >
        {
        this.props.location.state&&this.props.location.state.isDid===true?<p></p>:
        <p className="gf_Time"><span className="gft_l">{this.state.timeMin}</span><span className="gft_r">考试用时：<span className="time_down">{this.state.time}</span></span></p>
        }
      
         
         <div className="qus_con">
           {
             this.state.questionDates&&this.state.questionDates.map((value,key)=>{
               if(value.questionType==="1001"){
                 return(
                  <Single  data={[value]} ansShow={this.props.location.state.isDid}  key={key} Skey={key+1} subCard={this.subCard} imgShow={this.imgShow} listXX="单选"  isDid={isDid}></Single>
                 )
               }else if(value.questionType==="1002"){
                return(
                <Multi data={[value]} key={key} Skey={key+1} ansShow={this.props.location.state.isDid} subCard={this.subCard} imgShow={this.imgShow}  listXX="多选" isDid={isDid}></Multi>
               
                )
              }else if(value.questionType==="1016"){
                return(
                <Multi data={[value]} key={key} Skey={key+1} ansShow={this.props.location.state.isDid} subCard={this.subCard} imgShow={this.imgShow}  listXX="不定项选择" isDid={isDid}></Multi>
               
                )
              }else if(value.questionType==="1003"){
                return(
                  <Single data={[value]} ansShow={this.props.location.state.isDid}  key={key} Skey={key+1}  subCard={this.subCard} imgShow={this.imgShow}  isDan="1" listXX="判断" isDid={isDid}></Single>
               
                )
              }
              else if(value.questionType==="1013"){
                return(
                  <Completion data={[value]} ansShow={this.props.location.state.isDid}  key={key} Skey={key+1}  subCard={this.subCard} imgShow={this.imgShow}  listXX="填空" isDid={isDid}></Completion>
               
                )
              }
              else{
                return(
                  <MkTopic data={[value]}  ansShow={this.props.location.state.isDid} key={key} Skey={key+1}  subCard={this.subCard} imgShow={this.imgShow}  listXX="综合"></MkTopic>
               
                )
              }
             })
           }
        {/* <Completion data={this.state.activeDesigns}  subCard={this.subCard} imgShow={this.imgShow} title='填空题' listXX="题型"></Completion>
         
           <Multi data={this.state.multiList}  subCard={this.subCard} imgShow={this.imgShow} title='多项选择题' listXX="题型"></Multi>
          <Single data={this.state.judgeList}  subCard={this.subCard} imgShow={this.imgShow} title='判断题' isDan="1" listXX="题型"></Single>
          <Topic data={this.state.shortList}  subCard={this.subCard} imgShow={this.imgShow} title='简答题' listXX="题型"></Topic>
          <Topic data={this.state.analysList} subCard={this.subCard} imgShow={this.imgShow} title='辨析题' listXX="题型"></Topic>
          <Topic data={this.state.materAnalys}  subCard={this.subCard} imgShow={this.imgShow} title='材料分析题' listXX="题型"></Topic>
          <Topic data={this.state.writings}  subCard={this.subCard} imgShow={this.imgShow} title='写作题' listXX="题型"></Topic>
          <Topic data={this.state.desingns}  subCard={this.subCard} imgShow={this.imgShow} title='教学设计题' listXX="题型"></Topic>
          <Topic data={this.state.caseAnalys}  subCard={this.subCard} imgShow={this.imgShow} title='案例分析题' listXX="题型"></Topic>
          <Topic data={this.state.nounExplains}  subCard={this.subCard} imgShow={this.imgShow} title='名词解释题' listXX="题型"></Topic>
          <Topic data={this.state.discussTypes}  subCard={this.subCard} imgShow={this.imgShow} title='论述题' listXX="题型"></Topic>
          <Topic data={this.state.activeDesigns}  subCard={this.subCard} imgShow={this.imgShow} title='活动设计题' listXX="题型"></Topic> */}
        
          </div>
      
      </div>
      <Answersheet examType="1" onRef={this.onRef} history={this.props.history} isDid={this.state.isDid} paperId={this.props.location.state.paperId} userId={this.props.location.state.userId} examId={this.props.location.state.examId}></Answersheet>
      </div>
    );
          
  }
}

export default MK;
